var map = {
	"./br/PT/S1/bg149.jpg": 5064,
	"./br/PT/bg149.jpg": 33668,
	"./in/EN/S1/bg149.jpg": 81895,
	"./ph/EN/S1/bg149.jpg": 14185,
	"./ph/EN/bg149.jpg": 22473,
	"./vn/VI/S1/bg149.jpg": 92708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44981;